import type { FC, ReactNode } from 'react';

import { KnockProvider as KnockProviderBase } from '@knocklabs/react';

import { useAuth } from 'shared/lib/auth/useAuth';

type KnockProviderProps = {
  children: ReactNode;
};

const KNOCK_API_KEY = import.meta.env.VITE_APP_KNOCK_PUBLIC_API_KEY as string;

export const KnockProvider: FC<KnockProviderProps> = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const userId = user?.profile?.email;

  if (!isAuthenticated || !userId || !KNOCK_API_KEY) {
    return <>{children}</>;
  }

  return (
    <KnockProviderBase apiKey={KNOCK_API_KEY} userId={userId}>
      {children}
    </KnockProviderBase>
  );
};
